// extracted by mini-css-extract-plugin
module.exports = {"heading":"CommonSectionHeaderAfrica_heading__p2GTr","title":"CommonSectionHeaderAfrica_title__z8NGX","subtitle":"CommonSectionHeaderAfrica_subtitle__c_2lz"};